export default __webpack_public_path__ + "static/media/ceremonyMantoo.c37df525.svg";